// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"ebd4ff7d","247":"f38e6dc9","262":"f863e349","453":"73d7935b","465":"509bee01","662":"f7777f4c","723":"72b0f55f","724":"2abbf6db"}[chunkId] + ".chunk.js";
};